// React Dependencies
import React from 'react';

// External Dependencies
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { Button } from '@material-ui/core';

// Internal Dependencies
import OutletTable from './table';

const Outlets = ({ match }) => (
  <div className="row" style={{ backgroundColor: '#fff', marginLeft: 1 }}>
    <div className="col-lg-12 col-12" style={{ padding: 15 }}>
      <Link to={`${match.url}/add`}>
        <Button variant="contained" color="primary" size="medium">Add Outlet</Button>
      </Link>
    </div>
    <div className="col-lg-12 col-12 card-left">
      <OutletTable pageId={(match && match.params) ? match.params.id : ''} />
      {/* <NewOutletTable pageId={(match && match.params) ? match.params.id : ''}/> */}
    </div>
  </div>
);

Outlets.propTypes = {
  match: PropTypes.shape(Object).isRequired,
};

export default Outlets;
